import React from 'react';
import styled from 'styled-components';
import Footer from '../Footer/Footer';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1; /* Espande il contenitore per occupare lo spazio disponibile */
  min-height: 100%; /* Altezza minima di tutto il layout */
`;

const MainContent = styled.main`
  flex-grow: 1; /* Espande il contenuto principale */
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 30vh;
  max-width: 1400px; /* Limita la larghezza */
  box-sizing: border-box;
  margin: 0 auto; /* Centra il contenuto */
  padding: 0 1rem;
   min-height: calc(100vh - 100px); /* Calcola l'altezza minima: altezza viewport meno il footer */

  @media (max-width: 768px) {
    min-height: calc(100vh - 20px); /* Regola per il mobile */
  }
`;

const FooterContainer = styled.footer`
  background-color: #cc0000; /* Colore del footer */
  width: 100%;
  text-align: center;
`;

const WrapperADS = ({ children }) => {
  return (
    <StyledWrapper>
      <MainContent>{children}</MainContent>
      <FooterContainer>
        <Footer />
      </FooterContainer>
    </StyledWrapper>
  );
};

export default WrapperADS;
